export default __webpack_public_path__ + "static/media/Raheem_Sterling.8f2f05e5.png";